module.exports = __webpack_public_path__ + "img/right_one.59330ff1.svg";